import TableWrapRowsBoot from '../StockItems/TableWrapRowsBoot';
import * as ServerComms from '../utilities/ServerComms';
import React, {useState}  from 'react';
import NormalBtn from '../StockItems/NormalBtn';

function App(props) {

  var fromWhere = props.fromWhere;

  var programSetID = props.programSetID;
  var sessionID = props.sessionID;
  var userID = props.userID;
  var signKey = props.signKey;
  var nosCredits = props.nosCredits;
  var setNosCredits = props.setNosCredits;
  var clickBack = props.clickBack;
  var currentList = props.currentList;

  var relevantLaunchInfo = props.relevantLaunchInfo;
  var addToExtraScreen = props.addToExtraScreen;
  var getHistoryWithDefaults = props.getHistoryWithDefaults;
  var history = props.history;
  var setHistory = props.setHistory;

  function setLaunchInfo(response){
    relevantLaunchInfo.v[3] = response.v[1].v[0];
    relevantLaunchInfo.v[4] = response.v[1].v[1];
    relevantLaunchInfo.v[5] = response.v[1].v[2];
    relevantLaunchInfo.v[6] = response.v[1].v[3];
    relevantLaunchInfo.v[8] = response.v[1].v[4];
    relevantLaunchInfo.v[9] = response.v[1].v[5];

    setHistory([...history]);
    setNosCredits(response.v[0].v);

  }

  const [isDoingSomething, setIsDoingSomething] = useState(false);

  function failFunction(e){
    setIsDoingSomething(false);
  }

  function clickAddTime(creditsAdded){
    return function(e){
      if (creditsAdded > nosCredits){
        addToExtraScreen({t:'credits',v:creditsAdded});
      }else{
        setIsDoingSomething({t:'addingTime', creditsAdded});
        var postFunction = function(responseIn){
          if (responseIn.t === 'atom'){
            if (responseIn.v === 'exceedDaysLimit'){
              window.alert('Maximum of 360 days can be credited');
            }else if (responseIn.v === 'insufficientCredits'){
              window.alert('Insufficient Credits');
              getHistoryWithDefaults();
            }
          }else if (responseIn.t === 'tuple'){
            if (fromWhere === 'addTime'){
              window.alert('Time Added!');
              clickBack();
            }else{
              window.alert('Launched!');
            }
            setLaunchInfo(responseIn);
          }
          setIsDoingSomething(false);
        }

        var allowSharing = 0;
        if (fromWhere !== 'addTime'){
          var p = window.confirm('Allow Cues.sg to help publicise your dApp on our publicity channels?');
          if (p){
            allowSharing = 1;
          }
        }
        if (signKey){
          var passObject = {
              u:'addTime',
              sessionID,
              userID,
              signKey,
              creditsAdded,
              currentList,
              programSetID,
              allowSharing,
            };
          ServerComms.fetchSomething(passObject, postFunction, failFunction, []);
        }
      }
    }
  }

  var title = 'Launch for...';
  var subterm = 'Launch';
  if (fromWhere === 'addTime'){
    title = 'Add...';
    subterm = 'Add';
  }

  var addTimePieces = [{d:30, t:5}, {d:60, t:10}, {d:90, t:14}, {d:180, t:25}];
  var addTimeRows = addTimePieces.map((aTime, index)=>{
    var callToAction = <NormalBtn onClick={clickAddTime(aTime.t)} title={subterm}/>

    if (isDoingSomething && isDoingSomething.t === 'addingTime' && isDoingSomething.creditsAdded === aTime.t){
      if (fromWhere === 'addTime'){
        callToAction = '[Adding...]';
      }else{
        callToAction = '[Launching...]';
      }
    }

    return <tr key={index}><td >{aTime.d} days</td><td>{aTime.t} credits</td><td>{callToAction}</td></tr> 
  })
//

  var addTimeHeader = [title, 'Cost', ''];
//
 
  return <div className="container py-5">
          <div className="row mb-4"><div className="col-lg-8 mx-auto text-center">
          <TableWrapRowsBoot headerCells={addTimeHeader} rows={addTimeRows} />
          <NormalBtn onClick={clickBack} title='Back' />
      </div></div>
          </div>
//

}


export default App;
